import Home01Icon from "@hugeicons/core-free-icons/Home01Icon";
import PackageProcessIcon from "@hugeicons/core-free-icons/PackageProcessIcon";
import Invoice01Icon from "@hugeicons/core-free-icons/Invoice01Icon";
import RepeatIcon from "@hugeicons/core-free-icons/RepeatIcon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import Table01Icon from "@hugeicons/core-free-icons/Table01Icon";
import Alert02Icon from "@hugeicons/core-free-icons/Alert02Icon";
import InjectionIcon from "@hugeicons/core-free-icons/InjectionIcon";
import { PHARMACY_ROLES } from "../constants/roles";

// Pharmacist Console nav. Overview leads, matching the ops console's own ordering
// (src/v2/ops/nav-config.js) -- Reorders, Quotations, then Orders. The route the
// console actually lands on (index -> orders, see ./routes.jsx) is unchanged: this is
// still a work queue first, Overview is just now reachable from the sidebar too.
export const PHARMACY_NAV = [
    { key: "overview", label: "Overview", path: "/v2/pharmacy/overview", icon: Home01Icon, roles: PHARMACY_ROLES },
    { key: "reorders", label: "Reorders", path: "/v2/pharmacy/reorders", icon: RepeatIcon, roles: PHARMACY_ROLES },
    { key: "quotations", label: "Quotations", path: "/v2/pharmacy/quotations", icon: Invoice01Icon, roles: PHARMACY_ROLES },
    { key: "orders", label: "Orders", path: "/v2/pharmacy/orders", icon: PackageProcessIcon, roles: PHARMACY_ROLES },
    // Purchase-order pages (list + detail) are reached from inside this screen, not from
    // Order Tracking Sheet — the legacy /order-tracking-sheet screen, reused as-is.
    { key: "tracking-sheet", label: "Order Tracking Sheet", path: "/v2/pharmacy/tracking-sheet", icon: Table01Icon, roles: PHARMACY_ROLES },
    { key: "action-needed", label: "Action Needed", path: "/v2/pharmacy/action-needed", icon: Alert02Icon, roles: PHARMACY_ROLES },
    { key: "glp1", label: "GLP-1 Dashboard", path: "/v2/pharmacy/glp1", icon: InjectionIcon, roles: PHARMACY_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/pharmacy/users", icon: UserMultipleIcon, roles: PHARMACY_ROLES },
];
